import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import MainContainer from './views/auth/components/MainContainer';

import { LOGIN, PROFILE, REGISTER } from './views/auth/routes';
import {
  EDIT_WAVELIGHTS,
  WAVELIGHTS,
  WAVELIGHT_WAVES,
  WAVELIGHT_WAVES_ITEMS,
  WAVELIGHT_WAVES_TECHNIQUES,
  WAVELIGHT_WAVES_TECHNIQUES_ITEM,
} from './views/wavelight/routes';

import { AuthState } from './views/auth/types';
import { useAppDispatch, useAppSelector } from './hooks';
import { getUserProfile, initializeLogin } from './views/auth/reducer';

import ProtectedRoute from './views/auth/components/ProtectedRoute';
import Login from './views/auth/pages/login';
import Register from './views/auth/pages/register';
import UserProfile from './views/auth/pages/user-profile';

import Workflow from './views/workflow/pages/workflow';
import Wavelights from './views/wavelight/pages/main';
import WavelightsItem from './views/wavelight/pages/wavelights-item';
import WavelightsWaves from './views/wavelight/pages/wavelights-waves';
import WavelightsWavesItem from './views/wavelight/pages/wavelights-waves-item';
import WavelightsWavesTechniques from './views/wavelight/pages/wavelights-waves-techniques';
import WavelightsWavesTechniquesItem from './views/wavelight/pages/wavelights-waves-techniques-item';
import { USERS } from './views/users/routers';
import Users from './views/users/pages/main';
import ResultsPage from './components/Results/ResultsPage';

function App() {
  const dispatch = useAppDispatch();
  const state: AuthState = useAppSelector((state) => state.auth);

  // Recover Tokens from LocalStorage
  useEffect(() => {
    dispatch(initializeLogin());
  }, [dispatch]);

  useEffect(() => {
    if (state.session.logged) {
      dispatch(getUserProfile());
    }
  }, [dispatch, state.session.logged]);

  if (state.session.recoveringSession) {
    return null;
  }

  return (
    <MainContainer>
      <Routes>
        {/* Auth */}
        <Route path={LOGIN()} element={<Login />} />
        <Route path={REGISTER()} element={<Register />} />
        <Route path={PROFILE()} element={<UserProfile />} />
        {/* App */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Workflow />
            </ProtectedRoute>
          }
        />
        <Route
          path="/send"
          element={
            <ProtectedRoute>
              <Workflow />
            </ProtectedRoute>
          }
        />
        <Route
          path={WAVELIGHTS()}
          element={
            <ProtectedRoute>
              <Wavelights />
            </ProtectedRoute>
          }
        />
        <Route
          path={EDIT_WAVELIGHTS(':id')}
          element={
            <ProtectedRoute>
              <WavelightsItem />
            </ProtectedRoute>
          }
        />
        <Route
          path={WAVELIGHT_WAVES(':id')}
          element={
            <ProtectedRoute>
              <WavelightsWaves />
            </ProtectedRoute>
          }
        />
        <Route
          path={WAVELIGHT_WAVES_ITEMS(':id', ':wid')}
          element={
            <ProtectedRoute>
              <WavelightsWavesItem />
            </ProtectedRoute>
          }
        />
        <Route
          path={WAVELIGHT_WAVES_TECHNIQUES(':id', ':wid')}
          element={
            <ProtectedRoute>
              <WavelightsWavesTechniques />
            </ProtectedRoute>
          }
        />
        <Route
          path={WAVELIGHT_WAVES_TECHNIQUES_ITEM(':id', ':wid', ':tid')}
          element={
            <ProtectedRoute>
              <WavelightsWavesTechniquesItem />
            </ProtectedRoute>
          }
        />
        <Route
          path={USERS()}
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/wavelights/:id/results"
          element={
            <ProtectedRoute>
              <ResultsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </MainContainer>
  );
}

export default App;
